// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-selector[data-v-9dc470e4]{width:70px;height:70px;border:2px solid #fff;cursor:pointer}@media(min-width:992px){.color-selector[data-v-9dc470e4]{width:77px;height:77px}}.color-selector span[data-v-9dc470e4]{font-size:30px}.text-black[data-v-9dc470e4]{color:#000}", ""]);
// Exports
module.exports = exports;
